// Stripe minor-unit handling — mirror of backend/utils/currency.py. Stripe
// `amount` is in the currency's smallest unit, and the scale is not always
// 1/100: zero-decimal currencies (JPY, CLP, …) charge in whole units. A blind
// `* 100` over-charges those 100×. Keep these tables in sync with the backend.

const ZERO_DECIMAL = new Set([
  'bif',
  'clp',
  'djf',
  'gnf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'ugx',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]);
const THREE_DECIMAL = new Set(['bhd', 'jod', 'kwd', 'omr', 'tnd']);

export function minorUnitExponent(currency: string | null | undefined): number {
  const c = (currency || 'eur').toLowerCase();
  if (ZERO_DECIMAL.has(c)) {
    return 0;
  }
  if (THREE_DECIMAL.has(c)) {
    return 3;
  }
  return 2;
}

export function toMinorUnits(
  majorAmount: number,
  currency: string | null | undefined
): number {
  const exponent = minorUnitExponent(currency);
  if (exponent === 3) {
    // 2-decimal presentment precision scaled to 1/1000 (a multiple of 10).
    return Math.round(majorAmount * 100) * 10;
  }
  return Math.round(majorAmount * 10 ** exponent);
}

export function fromMinorUnits(
  minorAmount: number,
  currency: string | null | undefined
): number {
  return minorAmount / 10 ** minorUnitExponent(currency);
}
